import { Reveal } from "./motion";
import { MapPin } from "lucide-react";
import { IMAGES } from "../../data";

const zones = [
  { dep: "10", name: "Aube", city: "Troyes · Romilly · Bar-sur-Aube" },
  { dep: "51", name: "Marne", city: "Reims · Châlons · Épernay" },
  { dep: "52", name: "Haute-Marne", city: "Chaumont · Saint-Dizier · Langres" },
];

export const Coverage = () => (
  <section id="zone" data-testid="coverage" className="relative py-28 lg:py-40 bg-[#080E19] overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.3em] text-champagne font-semibold mb-5">Zone desservie</p>
        <h2 className="font-serif font-light text-4xl sm:text-5xl text-[#F7F5F0] leading-tight mb-8">
          Au cœur de la <span className="italic text-champagne">Champagne</span> et au-delà
        </h2>
        <p className="text-[#94A3B8] leading-relaxed max-w-md mb-10">
          Basés au carrefour de l'Aube, de la Marne et de la Haute-Marne, nous vous conduisons vers toutes les destinations : aéroports parisiens, gares TGV, ou n'importe quelle adresse en France.
        </p>
        <div className="space-y-4">
          {zones.map((z, i) => (
            <div key={z.dep} data-testid={`zone-${z.dep}`} className="flex items-center gap-5 border border-white/10 rounded-xl p-5 bg-[#0C1322]/40 hover:border-champagne/30 transition-colors">
              <span className="font-serif text-champagne text-2xl w-10">{z.dep}</span>
              <div>
                <p className="text-[#F7F5F0] font-medium">{z.name}</p>
                <p className="text-[#94A3B8] text-sm">{z.city}</p>
              </div>
              <MapPin size={18} className="ml-auto text-champagne/60" />
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="spotlight rounded-2xl border border-white/10 overflow-hidden aspect-[4/5]">
          <img src={IMAGES.region} alt="Paysage de la région Champagne" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1400ms]" />
        </div>
      </Reveal>
    </div>
  </section>
);
